import { Fragment, useState } from "react";
import { useAppSelector } from "../../ReduxToolkit/Hooks";
import { H6, LI } from "../../AbstractElements";
import { MenuList } from "../../Data/Layout/Sidebar";
import { MenuItem } from "../../Types/Layout/Sidebar";
import MenuLists from "./MenuLists";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";

const SidebarMenuList = () => {
  const [activeMenu, setActiveMenu] = useState<string[]>([]);
  const { t } = useTranslation();
  const { pinedMenu } = useAppSelector((state) => state.layout);
  const { user } = useAuth();
  const role = user?.role;

  const shouldHideMenu = (mainMenu: MenuItem) => {
    return mainMenu?.Items?.map((data) => data.title).every((titles) =>
      pinedMenu.includes(titles || "")
    );
  };

  // Recursive filter with safe default
  const filterMenuByRole = (items: MenuItem[] = []): MenuItem[] => {
    if (!role) return []; // no role = no access
    return items
      .filter((item) => !item.roles || item.roles.includes(role))
      .map((item) => ({
        ...item,
        children: item.children ? filterMenuByRole(item.children) : undefined,
      }))
      .filter((item) => !item.children || item.children.length > 0);
  };

  return (
    <>
      {MenuList &&
        MenuList.map((mainMenu: MenuItem, index) => {
          const filteredItems = filterMenuByRole(mainMenu.Items ?? []); // 👈 Safe default
          if (filteredItems.length === 0) return null;

          return (
            <Fragment key={index}>
              <LI
                className={`sidebar-main-title ${
                  shouldHideMenu(mainMenu) ? "d-none" : ""
                }`}
              >
                <div>
                  <H6 className={mainMenu.lanClass && mainMenu.lanClass}>
                    {t(mainMenu.title)}
                  </H6>
                </div>
              </LI>
              <MenuLists
                menu={filteredItems}
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
                level={0}
              />
            </Fragment>
          );
        })}
    </>
  );
};

export default SidebarMenuList;
